import React from 'react';
import classNames from 'classnames';
import { Button } from '@moda/om';
import FilterIcon from '@moda/icons/filter-16';

import './ProductListingFilterToggle.scss';

type Props = {
  open: boolean;
  activeFilterCount: number;
  onClick: () => void;
};

export const ProductListingFilterToggle: React.FC<Props> = ({
  open,
  activeFilterCount,
  onClick
}) => (
  <Button
    className={classNames('ProductListingFilterToggle', {
      'ProductListingFilterToggle--open': open
    })}
    tertiary
    aria-expanded={open}
    onClick={onClick}
  >
    <FilterIcon />
    <span>{open ? 'Hide Filters' : 'Show Filters'}</span>
    {activeFilterCount > 0 && (
      <span className="ProductListingFilterToggle__count">({activeFilterCount})</span>
    )}
  </Button>
);
